import Navigation from "@/components/Navigation/Navigation";
import AppointmentsHeader from "@/components/AppointmentsComponents/AppointmentsHeader/AppointmentsHeader";
import AppointmentsMain from "@/components/AppointmentsComponents/AppointmentsMain/AppointmentsMain";

import "./AppointmentsPage.scss";

export default function AppointmentsPage() {
    return (
        <div className='container'>
            <Navigation />
            <div className='main_content appoints_main_content'>
                <AppointmentsHeader />
                <AppointmentsMain />
            </div>
        </div>
    );
}
